import { Experiments } from 'CustomOptimizelyProvider'
import { PossibleVariants } from 'utils/tracking/optimizely/types'
import type { GateContext } from '../gates.types'

type Cat4784Context = Pick<GateContext, 'experimentData' | 'tenant'>

export const isCat4784SmavaDacSkipButtonVarB = ({
  experimentData,
  tenant
}: Cat4784Context): boolean =>
  tenant === 'smava' &&
  experimentData[Experiments.CAT_4784_DAC_SKIP_BUTTON_V5] ===
    PossibleVariants.VARIATION_B
